function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.545 24v-2.804H8.45c-1.621 0-1.94-.42-1.94-2.524V15.13c0-1.746-1.12-2.868-3.186-3.008v-.23c2.066-.14 3.185-1.274 3.185-3.007V5.328c0-2.103.32-2.524 1.941-2.524h1.096V0H7.707c-3.3 0-4.373 1.16-4.373 4.729v2.816c0 2.014-.822 2.792-3.334 2.677v3.556c2.512-.102 3.334.675 3.334 2.69v2.803c0 3.57 1.073 4.729 4.373 4.729h1.838zM16.293 24c3.3 0 4.373-1.16 4.373-4.729v-2.804c0-2.013.822-2.79 3.334-2.689v-3.556c-2.512.115-3.334-.663-3.334-2.677V4.73c0-3.57-1.073-4.729-4.373-4.729h-1.838v2.804h1.096c1.621 0 1.94.42 1.94 2.524v3.556c0 1.733 1.12 2.867 3.186 3.008v.23c-2.066.14-3.185 1.26-3.185 3.007v3.543c0 2.103-.32 2.524-1.941 2.524h-1.096V24h1.838z"
});

function SvgObject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgObject;